import React from "react";

import BorderBox from "@src/sharedComponents/BorderBox/BorderBox";
import BorderBoxBody from "@src/sharedComponents/BorderBox/BorderBoxBody";
import BorderBoxHeader from "@src/sharedComponents/BorderBox/BorderBoxHeader";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

import styles from "./SkeletonGoalTable.module.css";

const SkeletonGoalTable: React.FC = () => {
  return (
    <BorderBox className={styles.container}>
      <BorderBoxHeader start={<div />} className={styles.header} />
      <BorderBoxBody className={styles.body}>
        <Skeleton className={styles.skeleton} height={25} />
        <Skeleton className={styles.skeleton} height={25} />
        <Skeleton className={styles.skeleton} height={25} />
        <Skeleton className={styles.skeleton} height={25} />
        <Skeleton className={styles.skeleton} height={25} />
      </BorderBoxBody>
    </BorderBox>
  );
};

export default SkeletonGoalTable;
